import React from "react";
import { Dialog, DialogType, DialogFooter, DefaultButton, Stack, Text } from "@fluentui/react";
import ChatOutlined from "@mui/icons-material/ChatOutlined";
import OpenInNew from "@mui/icons-material/OpenInNew";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import styles from "./SupportDialog.module.css";

interface SupportDialogProps {
    isOpen: boolean;
    dgName: string;
    onDismiss: () => void;
}

const SupportDialog: React.FC<SupportDialogProps> = ({ isOpen, dgName, onDismiss }) => {
    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onDismiss}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Need help?",
                subText: "Here are 3 ways to get support:",
                showCloseButton: true,
            }}
            modalProps={{
                isBlocking: false,
                styles: { main: { maxWidth: 480 } },
            }}
        >
            <Stack tokens={{ childrenGap: 16 }}>
                <Stack horizontal tokens={{ childrenGap: 12 }} verticalAlign="start">
                    <ChatOutlined className={styles.icon} />
                    <Stack tokens={{ childrenGap: 4 }}>
                        <Text className={styles.optionTitle}>
                            <a className={styles.link} onClick={onDismiss} role="button" style={{ cursor: "pointer" }}>
                                Ask the Assistant
                            </a>
                        </Text>
                        <Text className={styles.optionDescription}>
                            Type your question directly in the chat - the assistant can help with many topics.
                        </Text>
                    </Stack>
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 12 }} verticalAlign="start">
                    <OpenInNew className={styles.icon} />
                    <Stack tokens={{ childrenGap: 4 }}>
                        <Text className={styles.optionTitle}>
                            <a
                                href="https://eceuropaeu.sharepoint.com/sites/intpa-working-methods/SitePages/ai-at-intpa.aspx"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                AI {dgName} Intranet
                            </a>
                        </Text>
                        <Text className={styles.optionDescription}>
                            Visit the {dgName} AI intranet page for guides, FAQs and updates.
                        </Text>
                    </Stack>
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 12 }} verticalAlign="start">
                    <EmailOutlined className={styles.icon} />
                    <Stack tokens={{ childrenGap: 4 }}>
                        <Text className={styles.optionTitle}>
                            <a
                                href="mailto:ec-external-relations-application-support@ec.europa.eu"
                                className={styles.link}
                            >
                                Contact ERAS
                            </a>
                        </Text>
                        <Text className={styles.optionDescription}>
                            Send an email to the ERAS support team for technical issues.
                        </Text>
                    </Stack>
                </Stack>
            </Stack>
            <DialogFooter>
                <DefaultButton text="Close" onClick={onDismiss} />
            </DialogFooter>
        </Dialog>
    );
};

export default SupportDialog;
